import React, { useState } from 'react';
import { Layout, Typography, Form, Input, Button, Alert, Spin } from 'antd';
import { UserOutlined, LockOutlined, IdcardOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './AdminRegister.css';

const { Content, Header } = Layout;
const { Title, Text } = Typography;

const AdminRegister = () => {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await fetch('/backend/admin_register.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          email: values.email,
          password: values.password,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setSuccess('Registration successful! You will be redirected to the login page.');
        setError(null);
        form.resetFields();
        setTimeout(() => navigate('/adminlogin'), 2000);
      } else {
        setError(result.error || 'Error during registration.');
        setSuccess(null);
      }
    } catch (error) {
      setError('An error occurred during registration.');
      setSuccess(null);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <Layout className="auth-layout">
      <Header className="auth-header">
        <div className="logo">
          <IdcardOutlined className="logo-icon" />
          <Title level={4} className="logo-text">
            NH Guide - Service Provider
          </Title>
        </div>
      </Header>
      <Content className="auth-content">
        <div className="auth-container">
          <Title level={2} className="auth-title">
            Service Provider Registration
          </Title>
          <Text className="auth-subtitle">
            Create a Service Provider account to manage NH Guide.
          </Text>
          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              className="auth-alert auth-alert-error"
            />
          )}
          {success && (
            <Alert
              message={success}
              type="success"
              showIcon
              className="auth-alert auth-alert-success"
            />
          )}
          <Form
            form={form}
            name="adminRegister"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="vertical"
            className="auth-form"
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: 'Please enter your email!' },
                { type: 'email', message: 'Please enter a valid email!' },
              ]}
            >
              <Input
                prefix={<UserOutlined className="input-icon" />}
                placeholder="admin@example.com"
                size="large"
                className="auth-input"
              />
            </Form.Item>
            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: 'Please enter your password!' },
                { min: 6, message: 'The password must be at least 6 characters long!' },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined className="input-icon" />}
                placeholder="Password"
                size="large"
                className="auth-input"
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                block
                className="auth-button"
                disabled={loading}
              >
                {loading ? <Spin size="small" /> : 'Register'}
              </Button>
            </Form.Item>
            <Text className="auth-link-text">
              Already have an account?{' '}
              <a onClick={() => navigate('/adminlogin')} className="auth-link">
                Log in
              </a>
            </Text>
          </Form>
        </div>
      </Content>
    </Layout>
  );
};

export default AdminRegister;